// extracted by mini-css-extract-plugin
module.exports = {"Work":"Work_Work___xqyS","animateh1":"Work_animateh1__3QxIS","WorkItem":"Work_WorkItem__2pmWB","animateitems":"Work_animateitems__3XysR"};